module.exports = __webpack_public_path__ + "static/media/SH 6.ba69e0cd.mp3";